import { render, staticRenderFns } from "./paymentCodeInquire.vue?vue&type=template&id=683c6fe2&scoped=true&"
import script from "./paymentCodeInquire.vue?vue&type=script&lang=ts&"
export * from "./paymentCodeInquire.vue?vue&type=script&lang=ts&"
import style0 from "./paymentCodeInquire.vue?vue&type=style&index=0&id=683c6fe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683c6fe2",
  null
  
)

export default component.exports